import { useMemo } from 'react';

import { envVariables } from '@/utils/env';

import { NAV_ITEMS, NavItem } from './navConfig';
import { useBamAuth } from './useBamAuth';

export function useNavItems(): NavItem[] {
  const { hasPermission } = useBamAuth();
  const env = envVariables();

  return useMemo(
    () =>
      NAV_ITEMS.filter((item) => {
        if (!hasPermission(item.requiredPermission)) return false;
        if (item.featureFlag && !env[item.featureFlag as keyof typeof env]) return false;
        return true;
      }),
    [hasPermission, env],
  );
}
